export const NOTIFICATION_HIDE_TIMEOUT = 3000;
